import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import DiscountBanner from '../components/DiscountBanner';
import ReviewBanner from '../components/ReviewBanner';

const FAQPage = () => {
  const faqs = [
    {
      id: 'faq-1',
      question: "What is in-home cat sitting?",
      answer: "In-home cat sitting means we come to your house to care for your cats while you're away. Your cats stay in their familiar environment rather than being taken to a cattery. We provide feeding, litter cleaning, playtime, health monitoring, and daily photo updates — all in the comfort of your home."
    },
    {
      id: 'faq-2',
      question: "How often do you visit?",
      answer: "We offer flexible visit schedules to suit your cats' needs. You can choose once daily visits (20-30 minutes), twice daily visits (20-30 minutes each), or VIP extended visits (45 minutes). During our meet and greet, we'll discuss which option is best for your cats."
    },
    {
      id: 'faq-3',
      question: "Do you give medication?",
      answer: "Yes, we're happy to administer medication if your cat requires it. Whether it's tablets, liquid medicine, or injections, we'll follow your instructions carefully. Please let us know about any medication needs during our meet and greet so we can ensure we're comfortable with the administration method."
    },
    {
      id: 'faq-4',
      question: "Will I receive updates?",
      answer: "Absolutely! You'll receive daily photo and message updates after each visit. We know how much you miss your cats while you're away, so we make sure you stay connected with regular updates on how they're doing, what they've been up to, and how they're feeling."
    },
    {
      id: 'faq-5',
      question: "Are you insured?",
      answer: "Yes, we are fully insured. We carry comprehensive insurance that covers both your cats and your home during our visits, giving you complete peace of mind."
    },
    {
      id: 'faq-6',
      question: "Do you offer a meet and greet?",
      answer: "Yes, we offer a free, no-obligation meet and greet before your first booking. This gives us a chance to meet you and your cats, see your home, discuss your cats' routines and preferences, and answer any questions you have. It's an important step in building trust and ensuring we're the right fit for your family."
    },
    {
      id: 'faq-7',
      question: "What areas do you cover?",
      answer: "We're based in Walsall and cover Walsall and the surrounding areas. If you're unsure whether we cover your location, please get in touch and we'll let you know straight away. We're always happy to discuss travel to nearby areas."
    },
    {
      id: 'faq-8',
      question: "What happens in an emergency?",
      answer: "Your cats' safety and wellbeing are our top priority. If we notice any health concerns during a visit, we'll contact you immediately. If your cat needs urgent veterinary care and we cannot reach you, we have your emergency contact details and vet information from our meet and greet, and we'll take appropriate action to ensure your cat receives the care they need."
    },
    {
      id: 'faq-9',
      question: "How do I book a service?",
      answer: "Booking is easy! Simply contact us via our contact form, email, phone, or WhatsApp. We'll arrange a free meet and greet at a time that suits you. After the meet and greet, if you'd like to proceed, we'll confirm your booking dates and send you all the details you need."
    },
    {
      id: 'faq-10',
      question: "What if my cat is shy or nervous?",
      answer: "Many cats are initially wary of new people, and we completely understand that. We take a calm, patient, and gentle approach, allowing your cat to get comfortable with us at their own pace. During the meet and greet, we'll observe your cat's personality and discuss the best approach for making them feel safe and secure during your absence."
    },
    {
      id: 'faq-11',
      question: "Can you care for other pets as well as cats?",
      answer: "Our specialist focus is on cats, as we believe in providing expert, dedicated care for feline friends. If you have other small pets such as rabbits or guinea pigs, we may be able to help — please get in touch to discuss your needs."
    },
    {
      id: 'faq-12',
      question: "What's included in the Home Guardians service?",
      answer: "Our Home Guardians service is included with all cat sitting visits at no extra charge. We'll open and close curtains, turn lights on and off, take in post and parcels, and put bins out. This helps keep your home looking lived-in and secure while you're away."
    },
    {
      id: 'faq-13',
      question: "How far in advance should I book?",
      answer: "We recommend booking as early as possible, especially during peak holiday periods like Christmas, Easter, and summer. However, we understand that plans can change, so if you need last-minute care, please get in touch and we'll do our best to accommodate you."
    },
    {
      id: 'faq-14',
      question: "What information do you need from me?",
      answer: "During our meet and greet, we'll gather all the essential information including your cats' feeding schedule and diet, litter tray preferences, medication needs (if any), personality quirks, hiding spots, your vet's contact details, and emergency contact information. We'll also discuss your home guardian preferences such as lighting and curtain schedules."
    },
    {
      id: 'faq-15',
      question: "Do you have a key holding service?",
      answer: "Yes, for your convenience and security, we can hold onto your keys between bookings if you're a regular client. All keys are stored securely and handled with the utmost care. Alternatively, you can provide keys before each trip and we'll return them upon your return."
    }
  ];

  return (
    <div className="faq-page">
      {/* Discount Banner - Top */}
      <DiscountBanner size="large" />
      
      {/* Review Banner */}
      <ReviewBanner />
      
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Frequently Asked Questions</h1>
          <p className="page-subtitle">Everything you need to know about our cat sitting services</p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <div className="faq-content">
            <Accordion type="single" collapsible className="faq-accordion">
              {faqs.map((faq) => (
                <AccordionItem key={faq.id} value={faq.id} className="faq-item">
                  <AccordionTrigger className="faq-question">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="faq-answer">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="faq-contact-section">
        <div className="container">
          <div className="faq-contact-box">
            <h2>Still Have Questions?</h2>
            <p>We're here to help! If you can't find the answer you're looking for, please don't hesitate to get in touch.</p>
            <div className="contact-options">
              <a href="tel:07344414860" className="contact-link">
                <span className="contact-label">Call:</span> 07344 414860
              </a>
              <a href="mailto:Enquiries@maidforcats.co.uk" className="contact-link">
                <span className="contact-label">Email:</span> Enquiries@maidforcats.co.uk
              </a>
              <a href="https://wa.me/447344414860" target="_blank" rel="noopener noreferrer" className="contact-link whatsapp-link">
                <span className="contact-label">WhatsApp:</span> Message Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;
